import { createSelector } from '@reduxjs/toolkit';
import { selectApp } from './selectApp';

/** Select full state of Customizer editor panel */
export const selectEditPanelState = createSelector([selectApp], (state) => state.editPanel);
